import type { DeepPartial } from '@luna/utils-ts';

import type { OwnTransfer } from './OwnTransfer';

export const CZ: DeepPartial<OwnTransfer> = {};
